// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/App.css - COMPLETE AND RECTIFIED */

/* ==========================================
   CSS VARIABLES (Light Theme)
   ========================================== */
:root {
  /* Primary Red Palette */
  --primary-red-light: #ef4444; /* Brighter Red */
  --primary-red-medium: #dc2626; /* Medium Red */
  --primary-red-dark: #991b1b;  /* Darker Red */
  --primary-black: #000000;   /* Black */

  /* Gradients */
  --gradient-button: linear-gradient(to right, var(--primary-red-light), var(--primary-red-medium));
  --gradient-hero: linear-gradient(to bottom right, #FEF2F2, #FFF1F2); /* Light red/pink tint background */
  --gradient-text: linear-gradient(to right, var(--primary-red-medium), var(--primary-black));

  /* Backgrounds */
  --bg-primary: #FFFFFF;        /* White */
  --bg-secondary: #F9FAFB;    /* Very light gray (like gray-50) */
  --bg-accent-light: #FEF2F2; /* Light red tint (like red-50) */
  --bg-dark: var(--primary-black); /* Black (Primarily for Footer) */

  /* Text */
  --text-primary: #1F2937;    /* Dark gray/Almost Black */
  --text-secondary: #6B7280; /* Medium gray */
  --text-light: #FFFFFF;      /* White */
  --text-accent: var(--primary-red-medium); /* Red for highlights/links */
  --text-on-gradient: #FFFFFF; /* White text for gradient buttons */

  /* Borders */
  --border-primary: #E5E7EB;   /* Light gray border */
  --border-accent: #FCA5A5;    /* Light red border */
  --border-dark: var(--primary-black); /* Black border */

  /* Status Colors */
  --success-color: #10B981; /* Green */
  --warning-color: #F59E0B; /* Amber */
  --error-color: #EF4444;   /* Red */
  --success-bg-light: #ECFDF5; /* Green tint */
  --warning-bg-light: #FFFBEB; /* Yellow tint */
  --error-bg-light: #FEF2F2;   /* Red tint */

  /* Shadows (Approximations from Tailwind classes) */
  --shadow-lg: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  --shadow-xl: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  --shadow-2xl: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  --shadow-button-hover: 0 10px 15px -3px rgba(220, 38, 38, 0.3); /* Reddish hover shadow */

  /* --- Navbar (UPDATED FOR LIGHT THEME) --- */
  --navbar-height: 5rem; /* 64px */
  --navbar-bg: rgba(255, 255, 255, 0.98); /* Nearly opaque white */
  --navbar-border: var(--border-primary); /* Light gray border */
  --navbar-text: var(--text-secondary); /* Medium gray text */
  --navbar-text-hover: var(--text-accent); /* Red text on hover */
  --navbar-font-weight: 500; /* Medium */

  /* Footer (Remains Dark) */
  --footer-bg: var(--bg-dark); /* Black */
  --footer-text: #9CA3AF;    /* Gray-400 */
  --footer-link-hover: var(--text-accent); /* Red link hover */
  --footer-border: #374151;  /* Gray-700 */

  /* General */
  --border-radius-full: 9999px; /* rounded-full */
  --border-radius-lg: 0.5rem; /* rounded-lg */
  --border-radius-xl: 0.75rem; /* rounded-xl */
  --border-radius-2xl: 1rem; /* rounded-2xl */
  --border-radius-3xl: 1.5rem; /* rounded-3xl */
}

/* ==========================================
   BASE SETUP, CONTAINERS, AND LAYOUT
   ========================================== */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html {
  scroll-behavior: smooth;
  -webkit-text-size-adjust: 100%;
}

body {
  font-family: 'Inter', sans-serif;
  background: var(--bg-primary); /* Default to white background */
  color: var(--text-primary);
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  overflow-x: hidden;
  line-height: 1.6;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.container {
  width: 100%;
  max-width: 1280px; /* max-w-7xl */
  margin: 0 auto;
  padding: 0 1rem; /* px-4 */
}
@media (min-width: 640px) {
  .container { padding: 0 1.5rem; } /* sm:px-6 */
}
@media (min-width: 1024px) {
  .container { padding: 0 2rem; } /* lg:px-8 */
}

.main-content {
  flex: 1 1;
  /* Apply light gradient to main content area for pages like Workbench */
  background: var(--gradient-hero);
}

/* ==========================================
   NAVBAR STYLES
   ========================================== */
.navbar {
  background: var(--navbar-bg);
  backdrop-filter: blur(8px);
  border-bottom: 1px solid var(--navbar-border);
  position: sticky;
  top: 0;
  z-index: 50;
  height: var(--navbar-height);
  width: 100%;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.navbar-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 1rem;
  height: 100%;
  position: relative; /* Essential for absolute positioning children */
}

.logo-link {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  text-decoration: none;
  z-index: 52; /* Ensure logo stays above mobile menu */
}

.navbar-logo {
  height: 4rem;
  width: auto;
  max-width: 300px;
  object-fit: contain;
}

/* --- NEW: Navbar Actions Container --- */
/* Wraps the greeting and toggle button so they stay together */
.navbar-actions {
  display: flex;
  align-items: center;
  gap: 1rem;
  z-index: 52; /* Ensure buttons stay above mobile menu */
}

/* Mobile Toggle Button */
.mobile-nav-toggle {
  display: block;
  color: var(--navbar-text); 
  background: none;
  border: none;
  cursor: pointer;
  font-size: 1.75rem; /* Larger click target */
  line-height: 1;
  padding: 0.5rem;
  transition: color 0.3s ease;
}
.mobile-nav-toggle:hover {
  color: var(--navbar-text-hover); 
}

/* --- MOBILE NAV LINKS (DEFAULT STATE) --- */
.nav-links {
  display: none; /* Hidden by default on mobile */
  flex-direction: column;
  position: absolute;
  top: 100%; /* Directly below navbar */
  left: 0;
  right: 0; /* Span full width */
  width: 100%;
  background-color: white; /* Solid background to cover content */
  border-bottom: 1px solid var(--border-primary);
  padding: 1.5rem 1rem;
  gap: 1.5rem;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
  list-style: none;
  z-index: 1000; /* Very high z-index to float over EVERYTHING */
  align-items: center;
  pointer-events: auto; /* Ensure links are clickable */
}

/* --- MOBILE NAV LINKS (OPEN STATE) --- */
.nav-links.open {
  display: flex !important; /* Force display when open class is present */
  animation: slideDown 0.3s ease-out forwards;
}

@keyframes slideDown {
  from { opacity: 0; transform: translateY(-10px); }
  to { opacity: 1; transform: translateY(0); }
}

/* Link Styles */
.nav-link {
  color: var(--navbar-text); 
  text-decoration: none;
  transition: color 0.3s ease;
  font-size: 1.1rem; /* Slightly larger on mobile for touch targets */
  font-weight: 600;
  display: block;
  padding: 0.5rem 0;
  width: 100%;
  text-align: center;
  background: none;
  border: none;
  cursor: pointer;
}

.nav-link:hover {
  color: var(--navbar-text-hover); 
  background-color: var(--bg-secondary); 
  border-radius: 8px;
}

/* Register/Signup Button specific styling */
.nav-link.register-link {
  background: var(--gradient-button);
  color: var(--text-on-gradient);
  padding: 0.8rem 2rem;
  border-radius: var(--border-radius-full);
  text-align: center;
  width: 100%;
  max-width: 250px;
  border: 2px solid var(--primary-red-medium);
}
.nav-link.register-link:hover {
  box-shadow: var(--shadow-button-hover);
  transform: scale(1.05);
}

/* Mobile Greeting */
.user-greeting-mobile {
  display: inline-block;
  font-size: 0.9rem;
  font-weight: 600;
  color: var(--text-primary);
}

.user-greeting {
    display: none; /* Hidden on mobile, shown on desktop */
}

/* --- DESKTOP STYLES (Over 768px) --- */
@media (min-width: 768px) {
  /* Hide Mobile Elements */
  .mobile-nav-toggle { display: none; }
  .user-greeting-mobile { display: none; }
  
  /* Show Desktop Greeting */
  .user-greeting {
      display: inline-block;
      color: var(--navbar-text);
      font-size: 0.875rem;
      margin-right: 1rem;
      font-weight: 600;
  }

  /* Reset Nav Links layout for Desktop Row */
  .nav-links {
    display: flex; /* Always visible */
    flex-direction: row;
    position: static;
    width: auto;
    height: auto;
    background: transparent;
    border: none;
    box-shadow: none;
    padding: 0;
    gap: 2rem;
    animation: none;
    z-index: auto;
    transform: none;
  }
  
  /* Ensure .open class doesn't mess up desktop layout */
  .nav-links.open {
    display: flex;
    flex-direction: row;
    position: static;
    box-shadow: none;
    animation: none;
  }

  /* Desktop specific link styling */
  .nav-link {
    font-size: 0.875rem;
    padding: 0.3rem 0.6rem;
    width: auto;
  }
  
  .nav-link.register-link {
     width: auto;
     padding: 0.5rem 1.5rem;
  }

  .nav-link:hover {
    background-color: var(--bg-secondary);
    border-radius: var(--border-radius-lg);
    margin: 0; 
  }
  
  /* Active State Line (Desktop Only) */
  .nav-links a.active::after {
    content: '';
    position: absolute;
    bottom: -4px;
    left: 0;
    width: 100%;
    height: 2px;
    background-color: var(--text-accent);
  }
  
  .nav-links .logout-btn.active::after { display: none; }
}


/* ==========================================
   FOOTER STYLES (Remains Dark)
   ========================================== */
.footer {
  background: var(--footer-bg);
  color: var(--footer-text);
  padding: 4rem 0 2rem;
  margin-top: auto;
}

.footer-content {
  display: grid;
  gap: 2rem;
}
@media (min-width: 768px) {
  .footer-content { grid-template-columns: repeat(4, 1fr); }
}

.footer-section h3 {
  color: var(--text-light); /* White heading for dark footer */
  font-weight: 600;
  margin-bottom: 1rem;
  font-size: 1rem;
}

.footer-links {
  list-style: none;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.footer-links a {
  color: var(--footer-text);
  text-decoration: none;
  transition: color 0.3s ease;
  font-size: 0.875rem;
}

.footer-links a:hover {
  color: var(--footer-link-hover);
}

.footer-section p {
  color: var(--footer-text);
  font-size: 0.875rem;
  margin-bottom: 1rem;
}

.footer-social-links {
  display: flex;
  gap: 1rem;
}

.footer-social-links a {
  color: var(--footer-text);
  transition: color 0.3s ease;
}

.footer-social-links a:hover {
  color: var(--footer-link-hover);
}

.footer-social-links svg {
  width: 1.5rem;
  height: 1.5rem;
}

.footer-bottom {
  border-top: 1px solid var(--footer-border);
  margin-top: 3rem;
  padding-top: 2rem;
  text-align: center;
  color: var(--footer-text);
  font-size: 0.875rem;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,yCAAyC;;AAGzC;;+CAE+C;AAC/C;EACE,wBAAwB;EACxB,4BAA4B,EAAE,iBAAiB;EAC/C,6BAA6B,EAAE,eAAe;EAC9C,2BAA2B,GAAG,eAAe;EAC7C,wBAAwB,IAAI,UAAU;;EAEtC,cAAc;EACd,iGAAiG;EACjG,mEAAmE,EAAE,mCAAmC;EACxG,2FAA2F;;EAE3F,gBAAgB;EAChB,qBAAqB,SAAS,UAAU;EACxC,uBAAuB,KAAK,mCAAmC;EAC/D,0BAA0B,EAAE,iCAAiC;EAC7D,+BAA+B,EAAE,iCAAiC;;EAElE,SAAS;EACT,uBAAuB,KAAK,2BAA2B;EACvD,yBAAyB,EAAE,gBAAgB;EAC3C,qBAAqB,OAAO,UAAU;EACtC,wCAAwC,EAAE,6BAA6B;EACvE,2BAA2B,EAAE,oCAAoC;;EAEjE,YAAY;EACZ,yBAAyB,IAAI,sBAAsB;EACnD,wBAAwB,KAAK,qBAAqB;EAClD,mCAAmC,EAAE,iBAAiB;;EAEtD,kBAAkB;EAClB,wBAAwB,EAAE,UAAU;EACpC,wBAAwB,EAAE,UAAU;EACpC,sBAAsB,IAAI,QAAQ;EAClC,2BAA2B,EAAE,eAAe;EAC5C,2BAA2B,EAAE,gBAAgB;EAC7C,yBAAyB,IAAI,aAAa;;EAE1C,mDAAmD;EACnD,oFAAoF;EACpF,sFAAsF;EACtF,mDAAmD;EACnD,8DAA8D,EAAE,yBAAyB;;EAEzF,6CAA6C;EAC7C,qBAAqB,EAAE,SAAS;EAChC,sCAAsC,EAAE,wBAAwB;EAChE,sCAAsC,EAAE,sBAAsB;EAC9D,oCAAoC,EAAE,qBAAqB;EAC3D,uCAAuC,EAAE,sBAAsB;EAC/D,yBAAyB,EAAE,WAAW;;EAEtC,0BAA0B;EAC1B,2BAA2B,EAAE,UAAU;EACvC,sBAAsB,KAAK,aAAa;EACxC,uCAAuC,EAAE,mBAAmB;EAC5D,wBAAwB,GAAG,aAAa;;EAExC,YAAY;EACZ,4BAA4B,EAAE,iBAAiB;EAC/C,0BAA0B,EAAE,eAAe;EAC3C,2BAA2B,EAAE,eAAe;EAC5C,yBAAyB,EAAE,gBAAgB;EAC3C,2BAA2B,EAAE,gBAAgB;AAC/C;;AAEA;;+CAE+C;AAC/C;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA;EACE,gCAAgC;EAChC,6BAA6B,EAAE,gCAAgC;EAC/D,0BAA0B;EAC1B,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,iBAAiB,EAAE,cAAc;EACjC,cAAc;EACd,eAAe,EAAE,SAAS;AAC5B;AACA;EACE,aAAa,iBAAiB,EAAE,EAAE,YAAY;AAChD;AACA;EACE,aAAa,eAAe,EAAE,EAAE,YAAY;AAC9C;;AAEA;EACE,SAAO;EACP,uEAAuE;EACvE,gCAAgC;AAClC;;AAEA;;+CAE+C;AAC/C;EACE,4BAA4B;EAC5B,0BAA0B;EAC1B,6CAA6C;EAC7C,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,4BAA4B;EAC5B,WAAW;EACX,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,YAAY;EACZ,kBAAkB,EAAE,gDAAgD;AACtE;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,qBAAqB;EACrB,WAAW,EAAE,wCAAwC;AACvD;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,0CAA0C;AAC1C,+DAA+D;AAC/D;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW,EAAE,0CAA0C;AACzD;;AAEA,yBAAyB;AACzB;EACE,cAAc;EACd,yBAAyB;EACzB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,kBAAkB,EAAE,wBAAwB;EAC5C,cAAc;EACd,eAAe;EACf,2BAA2B;AAC7B;AACA;EACE,+BAA+B;AACjC;;AAEA,6CAA6C;AAC7C;EACE,aAAa,EAAE,gCAAgC;EAC/C,sBAAsB;EACtB,kBAAkB;EAClB,SAAS,EAAE,0BAA0B;EACrC,OAAO;EACP,QAAQ,EAAE,oBAAoB;EAC9B,WAAW;EACX,uBAAuB,EAAE,sCAAsC;EAC/D,8CAA8C;EAC9C,oBAAoB;EACpB,WAAW;EACX,+CAA+C;EAC/C,gBAAgB;EAChB,aAAa,EAAE,+CAA+C;EAC9D,mBAAmB;EACnB,oBAAoB,EAAE,+BAA+B;AACvD;;AAEA,0CAA0C;AAC1C;EACE,wBAAwB,EAAE,6CAA6C;EACvE,2CAA2C;AAC7C;;AAEA;EACE,OAAO,UAAU,EAAE,4BAA4B,EAAE;EACjD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA,gBAAgB;AAChB;EACE,yBAAyB;EACzB,qBAAqB;EACrB,2BAA2B;EAC3B,iBAAiB,EAAE,gDAAgD;EACnE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,+BAA+B;EAC/B,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA,4CAA4C;AAC5C;EACE,kCAAkC;EAClC,8BAA8B;EAC9B,oBAAoB;EACpB,wCAAwC;EACxC,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,2CAA2C;AAC7C;AACA;EACE,sCAAsC;EACtC,sBAAsB;AACxB;;AAEA,oBAAoB;AACpB;EACE,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;IACI,aAAa,EAAE,uCAAuC;AAC1D;;AAEA,wCAAwC;AACxC;EACE,yBAAyB;EACzB,qBAAqB,aAAa,EAAE;EACpC,wBAAwB,aAAa,EAAE;;EAEvC,0BAA0B;EAC1B;MACI,qBAAqB;MACrB,yBAAyB;MACzB,mBAAmB;MACnB,kBAAkB;MAClB,gBAAgB;EACpB;;EAEA,2CAA2C;EAC3C;IACE,aAAa,EAAE,mBAAmB;IAClC,mBAAmB;IACnB,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,uBAAuB;IACvB,YAAY;IACZ,gBAAgB;IAChB,UAAU;IACV,SAAS;IACT,eAAe;IACf,aAAa;IACb,eAAe;EACjB;;EAEA,sDAAsD;EACtD;IACE,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;EACjB;;EAEA,kCAAkC;EAClC;IACE,mBAAmB;IACnB,sBAAsB;IACtB,WAAW;EACb;;EAEA;KACG,WAAW;KACX,sBAAsB;EACzB;;EAEA;IACE,qCAAqC;IACrC,sCAAsC;IACtC,SAAS;EACX;;EAEA,qCAAqC;EACrC;IACE,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,OAAO;IACP,WAAW;IACX,WAAW;IACX,oCAAoC;EACtC;;EAEA,uCAAuC,aAAa,EAAE;AACxD;;;AAGA;;+CAE+C;AAC/C;EACE,4BAA4B;EAC5B,yBAAyB;EACzB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;AACA;EACE,kBAAkB,qCAAqC,EAAE;AAC3D;;AAEA;EACE,wBAAwB,EAAE,kCAAkC;EAC5D,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,0CAA0C;EAC1C,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;AACrB","sourcesContent":["/* src/App.css - COMPLETE AND RECTIFIED */\n@import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap');\n\n/* ==========================================\n   CSS VARIABLES (Light Theme)\n   ========================================== */\n:root {\n  /* Primary Red Palette */\n  --primary-red-light: #ef4444; /* Brighter Red */\n  --primary-red-medium: #dc2626; /* Medium Red */\n  --primary-red-dark: #991b1b;  /* Darker Red */\n  --primary-black: #000000;   /* Black */\n\n  /* Gradients */\n  --gradient-button: linear-gradient(to right, var(--primary-red-light), var(--primary-red-medium));\n  --gradient-hero: linear-gradient(to bottom right, #FEF2F2, #FFF1F2); /* Light red/pink tint background */\n  --gradient-text: linear-gradient(to right, var(--primary-red-medium), var(--primary-black));\n\n  /* Backgrounds */\n  --bg-primary: #FFFFFF;        /* White */\n  --bg-secondary: #F9FAFB;    /* Very light gray (like gray-50) */\n  --bg-accent-light: #FEF2F2; /* Light red tint (like red-50) */\n  --bg-dark: var(--primary-black); /* Black (Primarily for Footer) */\n\n  /* Text */\n  --text-primary: #1F2937;    /* Dark gray/Almost Black */\n  --text-secondary: #6B7280; /* Medium gray */\n  --text-light: #FFFFFF;      /* White */\n  --text-accent: var(--primary-red-medium); /* Red for highlights/links */\n  --text-on-gradient: #FFFFFF; /* White text for gradient buttons */\n\n  /* Borders */\n  --border-primary: #E5E7EB;   /* Light gray border */\n  --border-accent: #FCA5A5;    /* Light red border */\n  --border-dark: var(--primary-black); /* Black border */\n\n  /* Status Colors */\n  --success-color: #10B981; /* Green */\n  --warning-color: #F59E0B; /* Amber */\n  --error-color: #EF4444;   /* Red */\n  --success-bg-light: #ECFDF5; /* Green tint */\n  --warning-bg-light: #FFFBEB; /* Yellow tint */\n  --error-bg-light: #FEF2F2;   /* Red tint */\n\n  /* Shadows (Approximations from Tailwind classes) */\n  --shadow-lg: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);\n  --shadow-xl: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);\n  --shadow-2xl: 0 25px 50px -12px rgba(0, 0, 0, 0.25);\n  --shadow-button-hover: 0 10px 15px -3px rgba(220, 38, 38, 0.3); /* Reddish hover shadow */\n\n  /* --- Navbar (UPDATED FOR LIGHT THEME) --- */\n  --navbar-height: 5rem; /* 64px */\n  --navbar-bg: rgba(255, 255, 255, 0.98); /* Nearly opaque white */\n  --navbar-border: var(--border-primary); /* Light gray border */\n  --navbar-text: var(--text-secondary); /* Medium gray text */\n  --navbar-text-hover: var(--text-accent); /* Red text on hover */\n  --navbar-font-weight: 500; /* Medium */\n\n  /* Footer (Remains Dark) */\n  --footer-bg: var(--bg-dark); /* Black */\n  --footer-text: #9CA3AF;    /* Gray-400 */\n  --footer-link-hover: var(--text-accent); /* Red link hover */\n  --footer-border: #374151;  /* Gray-700 */\n\n  /* General */\n  --border-radius-full: 9999px; /* rounded-full */\n  --border-radius-lg: 0.5rem; /* rounded-lg */\n  --border-radius-xl: 0.75rem; /* rounded-xl */\n  --border-radius-2xl: 1rem; /* rounded-2xl */\n  --border-radius-3xl: 1.5rem; /* rounded-3xl */\n}\n\n/* ==========================================\n   BASE SETUP, CONTAINERS, AND LAYOUT\n   ========================================== */\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nhtml {\n  scroll-behavior: smooth;\n  -webkit-text-size-adjust: 100%;\n}\n\nbody {\n  font-family: 'Inter', sans-serif;\n  background: var(--bg-primary); /* Default to white background */\n  color: var(--text-primary);\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  overflow-x: hidden;\n  line-height: 1.6;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.container {\n  width: 100%;\n  max-width: 1280px; /* max-w-7xl */\n  margin: 0 auto;\n  padding: 0 1rem; /* px-4 */\n}\n@media (min-width: 640px) {\n  .container { padding: 0 1.5rem; } /* sm:px-6 */\n}\n@media (min-width: 1024px) {\n  .container { padding: 0 2rem; } /* lg:px-8 */\n}\n\n.main-content {\n  flex: 1;\n  /* Apply light gradient to main content area for pages like Workbench */\n  background: var(--gradient-hero);\n}\n\n/* ==========================================\n   NAVBAR STYLES\n   ========================================== */\n.navbar {\n  background: var(--navbar-bg);\n  backdrop-filter: blur(8px);\n  border-bottom: 1px solid var(--navbar-border);\n  position: sticky;\n  top: 0;\n  z-index: 50;\n  height: var(--navbar-height);\n  width: 100%;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n}\n\n.navbar-container {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  max-width: 1280px;\n  margin: 0 auto;\n  padding: 0 1rem;\n  height: 100%;\n  position: relative; /* Essential for absolute positioning children */\n}\n\n.logo-link {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  text-decoration: none;\n  z-index: 52; /* Ensure logo stays above mobile menu */\n}\n\n.navbar-logo {\n  height: 4rem;\n  width: auto;\n  max-width: 300px;\n  object-fit: contain;\n}\n\n/* --- NEW: Navbar Actions Container --- */\n/* Wraps the greeting and toggle button so they stay together */\n.navbar-actions {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  z-index: 52; /* Ensure buttons stay above mobile menu */\n}\n\n/* Mobile Toggle Button */\n.mobile-nav-toggle {\n  display: block;\n  color: var(--navbar-text); \n  background: none;\n  border: none;\n  cursor: pointer;\n  font-size: 1.75rem; /* Larger click target */\n  line-height: 1;\n  padding: 0.5rem;\n  transition: color 0.3s ease;\n}\n.mobile-nav-toggle:hover {\n  color: var(--navbar-text-hover); \n}\n\n/* --- MOBILE NAV LINKS (DEFAULT STATE) --- */\n.nav-links {\n  display: none; /* Hidden by default on mobile */\n  flex-direction: column;\n  position: absolute;\n  top: 100%; /* Directly below navbar */\n  left: 0;\n  right: 0; /* Span full width */\n  width: 100%;\n  background-color: white; /* Solid background to cover content */\n  border-bottom: 1px solid var(--border-primary);\n  padding: 1.5rem 1rem;\n  gap: 1.5rem;\n  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);\n  list-style: none;\n  z-index: 1000; /* Very high z-index to float over EVERYTHING */\n  align-items: center;\n  pointer-events: auto; /* Ensure links are clickable */\n}\n\n/* --- MOBILE NAV LINKS (OPEN STATE) --- */\n.nav-links.open {\n  display: flex !important; /* Force display when open class is present */\n  animation: slideDown 0.3s ease-out forwards;\n}\n\n@keyframes slideDown {\n  from { opacity: 0; transform: translateY(-10px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n\n/* Link Styles */\n.nav-link {\n  color: var(--navbar-text); \n  text-decoration: none;\n  transition: color 0.3s ease;\n  font-size: 1.1rem; /* Slightly larger on mobile for touch targets */\n  font-weight: 600;\n  display: block;\n  padding: 0.5rem 0;\n  width: 100%;\n  text-align: center;\n  background: none;\n  border: none;\n  cursor: pointer;\n}\n\n.nav-link:hover {\n  color: var(--navbar-text-hover); \n  background-color: var(--bg-secondary); \n  border-radius: 8px;\n}\n\n/* Register/Signup Button specific styling */\n.nav-link.register-link {\n  background: var(--gradient-button);\n  color: var(--text-on-gradient);\n  padding: 0.8rem 2rem;\n  border-radius: var(--border-radius-full);\n  text-align: center;\n  width: 100%;\n  max-width: 250px;\n  border: 2px solid var(--primary-red-medium);\n}\n.nav-link.register-link:hover {\n  box-shadow: var(--shadow-button-hover);\n  transform: scale(1.05);\n}\n\n/* Mobile Greeting */\n.user-greeting-mobile {\n  display: inline-block;\n  font-size: 0.9rem;\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n.user-greeting {\n    display: none; /* Hidden on mobile, shown on desktop */\n}\n\n/* --- DESKTOP STYLES (Over 768px) --- */\n@media (min-width: 768px) {\n  /* Hide Mobile Elements */\n  .mobile-nav-toggle { display: none; }\n  .user-greeting-mobile { display: none; }\n  \n  /* Show Desktop Greeting */\n  .user-greeting {\n      display: inline-block;\n      color: var(--navbar-text);\n      font-size: 0.875rem;\n      margin-right: 1rem;\n      font-weight: 600;\n  }\n\n  /* Reset Nav Links layout for Desktop Row */\n  .nav-links {\n    display: flex; /* Always visible */\n    flex-direction: row;\n    position: static;\n    width: auto;\n    height: auto;\n    background: transparent;\n    border: none;\n    box-shadow: none;\n    padding: 0;\n    gap: 2rem;\n    animation: none;\n    z-index: auto;\n    transform: none;\n  }\n  \n  /* Ensure .open class doesn't mess up desktop layout */\n  .nav-links.open {\n    display: flex;\n    flex-direction: row;\n    position: static;\n    box-shadow: none;\n    animation: none;\n  }\n\n  /* Desktop specific link styling */\n  .nav-link {\n    font-size: 0.875rem;\n    padding: 0.3rem 0.6rem;\n    width: auto;\n  }\n  \n  .nav-link.register-link {\n     width: auto;\n     padding: 0.5rem 1.5rem;\n  }\n\n  .nav-link:hover {\n    background-color: var(--bg-secondary);\n    border-radius: var(--border-radius-lg);\n    margin: 0; \n  }\n  \n  /* Active State Line (Desktop Only) */\n  .nav-links a.active::after {\n    content: '';\n    position: absolute;\n    bottom: -4px;\n    left: 0;\n    width: 100%;\n    height: 2px;\n    background-color: var(--text-accent);\n  }\n  \n  .nav-links .logout-btn.active::after { display: none; }\n}\n\n\n/* ==========================================\n   FOOTER STYLES (Remains Dark)\n   ========================================== */\n.footer {\n  background: var(--footer-bg);\n  color: var(--footer-text);\n  padding: 4rem 0 2rem;\n  margin-top: auto;\n}\n\n.footer-content {\n  display: grid;\n  gap: 2rem;\n}\n@media (min-width: 768px) {\n  .footer-content { grid-template-columns: repeat(4, 1fr); }\n}\n\n.footer-section h3 {\n  color: var(--text-light); /* White heading for dark footer */\n  font-weight: 600;\n  margin-bottom: 1rem;\n  font-size: 1rem;\n}\n\n.footer-links {\n  list-style: none;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.footer-links a {\n  color: var(--footer-text);\n  text-decoration: none;\n  transition: color 0.3s ease;\n  font-size: 0.875rem;\n}\n\n.footer-links a:hover {\n  color: var(--footer-link-hover);\n}\n\n.footer-section p {\n  color: var(--footer-text);\n  font-size: 0.875rem;\n  margin-bottom: 1rem;\n}\n\n.footer-social-links {\n  display: flex;\n  gap: 1rem;\n}\n\n.footer-social-links a {\n  color: var(--footer-text);\n  transition: color 0.3s ease;\n}\n\n.footer-social-links a:hover {\n  color: var(--footer-link-hover);\n}\n\n.footer-social-links svg {\n  width: 1.5rem;\n  height: 1.5rem;\n}\n\n.footer-bottom {\n  border-top: 1px solid var(--footer-border);\n  margin-top: 3rem;\n  padding-top: 2rem;\n  text-align: center;\n  color: var(--footer-text);\n  font-size: 0.875rem;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
